<script>
import axios from "axios";
// axios.defaults.baseURL = "http://127.0.0.1:8000/api";
axios.defaults.baseURL = "https://pharmadmin.afrimedsolutions.cloud/api";

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
} else {
  axios.defaults.headers.common["Authorization"] = "";
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
}

import appConfig from "@/app.config";
export default {
  name: "app",
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },

  data() {
    return {
      toastShown: false,
    }
  },
  mounted() {
    this.checkForUnauthorization();
  },

  methods: {

    handleUnauthorizedError() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('license');
      localStorage.removeItem('active_license');
      this.$router.push('/login');
      this.$toast.warning("Session expired, please login again");
      this.toastShown = true;
      setTimeout(() => {
        this.toastShown = false;
      }, 10000);
    },

    async checkForUnauthorization() {
      await axios.interceptors.response.use(
        response => response,
        error => {
          if (error.response.status === 401 && !this.toastShown) {
            this.handleUnauthorizedError();
          }
          // Add license expiration handling if needed
          if (error.response.status === 403 && error.response.data.message === 'License expired') {
            this.$router.push('/expired-license');
          }
          return Promise.reject(error);
        }
      );
    }
  }
};
</script>

<template>
  <div id="app">
    <RouterView />
    <Toasts :rtl="true" :max-messages="7" :showProgress="false" :time-out="5000" :closeable="false"></Toasts>
  </div>
</template>
